<section class="section price-agreements">
  <dashboard-price-agreements-summary [data]="summary"></dashboard-price-agreements-summary>
  <dashboard-price-agreements-expire-list [agreements]="expireList"></dashboard-price-agreements-expire-list>
</section>
